<script setup lang="ts">
import { useSlots } from 'vue';

const props = defineProps<{
    hideGroup?: boolean;
    groupClass?: 'input-group-lg' | 'input-group-sm';
}>();
const slots = useSlots();
</script>
<template>
    <slot v-if="props.hideGroup" />
    <div v-else class="input-group">
        <span v-if="slots['head']?.()" class="input-group-addon">
            <slot name="head" />
        </span>
        <span v-if="slots['head-btn']?.()" class="input-group-btn">
            <slot name="head-btn" />
        </span>
        <slot />
        <span v-if="slots['tail-btn']?.()" class="input-group-btn">
            <slot name="tail-btn" />
        </span>
        <span v-if="slots['tail']?.()" class="input-group-addon">
            <slot name="tail" />
        </span>
    </div>
</template>
